import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useIsMountedRef } from "@civicscience/chops";

type UseWindowResizeCheckReturn = {
  isWindowResizing: boolean;
};

const useWindowResizeCheck = (): UseWindowResizeCheckReturn => {
  const [isWindowResizing, setIsWindowResizing] = useState(false);
  const isMountedRef = useIsMountedRef(useRef, useEffect);

  useLayoutEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    const handleResize = () => {
      timeout && clearTimeout(timeout);

      isMountedRef.current && setIsWindowResizing(true);

      timeout = setTimeout(() => {
        isMountedRef.current && setIsWindowResizing(false);
      }, 200);
    };

    window.addEventListener("resize", handleResize, { passive: true });

    return () => window.removeEventListener("resize", handleResize);
  }, [isMountedRef]);

  return {
    isWindowResizing,
  };
};

export default useWindowResizeCheck;
